var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVieuniteSocialMediaIconsInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 135 135",
    style: {
      enableBackground: "new 0 0 135 135"
    },
    width: 40,
    height: 40,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0i{fill:#707070;}\r\n\t.st1i{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b5ff2bbe-8330-41bd-95e2-7fd16ecf3349"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0i",
    cx: 67.5,
    cy: 67.5,
    r: 67.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1i",
    d: "M67.5,32.7c11.3,0,12.7,0,17.2,0.2c2.7,0,5.4,0.5,7.9,1.5c3.7,1.4,6.6,4.4,8.1,8.1c0.9,2.5,1.4,5.2,1.5,7.9 c0.2,4.5,0.2,5.8,0.2,17.2s0,12.7-0.2,17.2c0,2.7-0.5,5.4-1.5,7.9c-1.4,3.7-4.4,6.6-8.1,8.1c-2.5,0.9-5.2,1.4-7.9,1.5 c-4.5,0.2-5.8,0.2-17.2,0.2s-12.7,0-17.2-0.2c-2.7,0-5.4-0.5-7.9-1.5c-3.7-1.4-6.6-4.4-8.1-8.1c-0.9-2.5-1.4-5.2-1.5-7.9 c-0.2-4.5-0.2-5.8-0.2-17.2s0-12.7,0.2-17.2c0-2.7,0.5-5.4,1.5-7.9c1.4-3.7,4.4-6.6,8.1-8.1c2.5-0.9,5.2-1.4,7.9-1.5 C54.8,32.7,56.2,32.7,67.5,32.7 M67.5,25c-11.5,0-13,0-17.5,0.3c-3.5,0.1-7,0.8-10.3,2C34,29.5,29.4,34,27.2,39.7 c-1.2,3.3-1.9,6.8-2,10.3C25,54.5,25,56,25,67.5s0,13,0.3,17.5c0.1,3.5,0.8,7,2,10.3c2.2,5.7,6.7,10.2,12.4,12.4 c3.3,1.2,6.8,1.9,10.3,2c4.5,0.2,6,0.3,17.5,0.3s13,0,17.5-0.3c3.5-0.1,7-0.8,10.3-2c5.7-2.2,10.2-6.7,12.4-12.4 c1.2-3.3,1.9-6.8,2-10.3c0.2-4.5,0.3-6,0.3-17.5s0-13-0.3-17.5c-0.1-3.5-0.8-7-2-10.3c-2.2-5.7-6.7-10.2-12.5-12.4 c-3.3-1.2-6.8-1.9-10.3-2C80.5,25,79,25,67.5,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1i",
    d: "M67.5,45.7c-12.1,0-21.8,9.8-21.8,21.8s9.8,21.8,21.8,21.8s21.8-9.8,21.8-21.8l0,0 C89.3,55.4,79.6,45.7,67.5,45.7z M67.5,81.7c-7.8,0-14.2-6.3-14.2-14.2s6.3-14.2,14.2-14.2c7.8,0,14.2,6.3,14.2,14.2 C81.7,75.3,75.3,81.7,67.5,81.7L67.5,81.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1i",
    cx: 90.2,
    cy: 44.8,
    r: 5.1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVieuniteSocialMediaIconsInstagram);
export default __webpack_public_path__ + "static/media/Vieunite Social Media Icons_Instagram.af6999a889b561ce8886bbbf778d503c.svg";
export { ForwardRef as ReactComponent };